import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { SelectField } from '../SelectField';
import { updateField } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { REDUX_KEY } from '../../redux/constants';
import { TARGET_AUDIENCE } from '../../constants';
import BasicGapContainer from './BasicGapContainer';

const TargetAudience = () => {
  const dispatch = useAppDispatch();
  const { demographic } = useAppSelector((state: RootState) => state.detail);

  const handleChange = (value: string): void => {
    const selectedDemographic = updateField({
      fieldName: REDUX_KEY.DEMOGRAPHIC,
      value
    });

    dispatch(selectedDemographic);
  };

  return (
    <BasicGapContainer>
      <h3>Target Audience</h3>
      <SelectField
        id="demographics"
        label="Demographics"
        options={Object.values(TARGET_AUDIENCE)}
        onChange={handleChange}
        value={demographic?.toString()}
      />
    </BasicGapContainer>
  );
};

export default TargetAudience;
